import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {
    user: any;
    userBlockVisible: boolean = false;

    constructor(public userblockService: UserblockService) {

        this.user = {
            name: localStorage.getItem("name"),
            picture: localStorage.getItem("picture") || 'assets/img/logo-single.png',
            role: localStorage.getItem("role")
        };
    }

    ngOnInit() {
        this.userBlockVisible = this.userblockService.getVisibility();
    }

}
